<h2 mat-dialog-title>A&ntilde;adir anexo</h2>
<form [formGroup]="addAnexoForm" (ngSubmit)="manageUploadAnexo()">
    <mat-dialog-content>
        <div class="files-container">
            <file-upload class="file-upload" formControlName="files" [multiple]="true" [animation]="false"
                [required]="true">
                <ng-template let-isFileDragDropAvailable="isFileDragDropAvailable" #placeholder>
                    <file-upload-drop-zone>
                        <b>Arrastre y suelte</b> archivos o click aqu&iacute;
                    </file-upload-drop-zone>
                </ng-template>
                <ng-template let-i="index" let-file="file" let-control="control" #item>
                  <file-upload-list-item  [index]="i" [file]="file" [control]="control">Remover</file-upload-list-item>
                </ng-template>
            </file-upload>
            @if (addAnexoForm.controls.files.hasError('fileNameTooLong')) {
            <mat-error class="files-container-label">
                Nombre archivo inválido {{
                addAnexoForm.controls.files.getError("fileNameTooLong").length+"/"+
                addAnexoForm.controls.files.getError("fileNameTooLong").maxLength }} caracteres.
            </mat-error>
            }
            @if (addAnexoForm.controls.files.hasError('required')) {
            <mat-error class="files-container-label">
                Seleccionar al menos un archivo
            </mat-error>
            }
            @if (addAnexoForm.controls.files.hasError('filesLimit')) {
            <mat-error class="files-container-label">{{ filesLimitMessageError }}</mat-error>
            }
            @if (addAnexoForm.controls.files.hasError('sizeLimit')) {
            <mat-error class="files-container-label">M&aacute;ximo 40 MB</mat-error>
            }@else{
            <mat-label class="files-container-label">{{updateKBsUsedDisplay()}}</mat-label>
            }
        </div>
        <mat-form-field class="form-field" appearance="outline">
            <mat-label>Descripci&oacute;n</mat-label>
            <textarea formControlName="description" matInput></textarea>
        </mat-form-field>
    </mat-dialog-content>
    <mat-dialog-actions>
        <button type="button" mat-button mat-dialog-close>Cancelar</button>
        <button type="submit" mat-flat-button [disabled]="!addAnexoForm.valid || postingAnexos">
            @if (postingAnexos) {
            <mat-spinner diameter="20" color="warn"></mat-spinner>
            }@else {
            <p>Subir</p>
            }
        </button>
    </mat-dialog-actions>
</form>
